// extracted by mini-css-extract-plugin
module.exports = {"primaryUser":"PrimaryUser_primaryUser__2Pz-s","avatar":"PrimaryUser_avatar__1y8Zu","name":"PrimaryUser_name__1G8yO","email":"PrimaryUser_email__dKP44"};